var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessment24PxBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "timeline-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-\\u6CA1\\u6709list",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeline-24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,8 C23,9.1 22.1,10 21,10 C20.82,10 20.65,9.98 20.49,9.93 L16.93,13.48 C16.98,13.64 17,13.82 17,14 C17,15.1 16.1,16 15,16 C13.9,16 13,15.1 13,14 C13,13.82 13.02,13.64 13.07,13.48 L10.52,10.93 C10.36,10.98 10.18,11 10,11 C9.82,11 9.64,10.98 9.48,10.93 L4.93,15.49 C4.98,15.65 5,15.82 5,16 C5,17.1 4.1,18 3,18 C1.9,18 1,17.1 1,16 C1,14.9 1.9,14 3,14 C3.18,14 3.35,14.02 3.51,14.07 L8.07,9.52 C8.02,9.36 8,9.18 8,9 C8,7.9 8.9,7 10,7 C11.1,7 12,7.9 12,9 C12,9.18 11.98,9.36 11.93,9.52 L14.48,12.07 C14.64,12.02 14.82,12 15,12 C15.18,12 15.36,12.02 15.52,12.07 L19.07,8.51 C19.02,8.35 19,8.18 19,8 C19,6.9 19.9,6 21,6 C22.1,6 23,6.9 23,8 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#0E78D5",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment24PxBlue);
export default __webpack_public_path__ + "static/media/assessment-24px-blue.824b5442.svg";
export { ForwardRef as ReactComponent };